import React from 'react';
import PropTypes from 'prop-types';

// import Creative Icons
import BeachChairWithBorderIcon from '../../icons/creative/BeachChairWithBorder';
import HeartShieldWithBorderIcon from '../../icons/creative/HeartShieldWithBorder';
import InformationWordBubbleIcon from '../../icons/creative/InformationWordBubble';
import LightbulbIcon from '../../icons/creative/Lightbulb';
import MoneyParachuteWithBorderIcon from '../../icons/creative/MoneyParachuteWithBorder';
import ProfileOutlineCheckmarkWithBorderIcon from '../../icons/creative/ProfileOutlineCheckmarkWithBorder';
import UmbrellaWithBorderIcon from '../../icons/creative/UmbrellaWithBorder';
import WomanWordBubbleLightbulb from '../../icons/creative/WomanWordBubbleLightbulb';
import QuotationIcon from '../../icons/creative/Quotation';
import ShieldWithClock from '../../icons/creative/ShieldWithClock';
import ShieldWithPlusSign from '../../icons/creative/ShieldWithPlusSign';
import ThumbsUp from '../../icons/creative/ThumbsUp';

// import Social Icons
import FacebookIcon from '../../icons/social/Facebook';
import InstagramIcon from '../../icons/social/Instagram';
import LinkedinIcon from '../../icons/social/Linkedin';
import PinterestIcon from '../../icons/social/Pinterest';
import TwitterIcon from '../../icons/social/Twitter';
import YoutubeIcon from '../../icons/social/Youtube';

// import Utility Icons
import AlertStrokeIcon from '../../icons/utility/AlertStroke';
import ChevronDownIcon from '../../icons/utility/ChevronDown';
import ChevronLeftIcon from '../../icons/utility/ChevronLeft';
import ChevronRightIcon from '../../icons/utility/ChevronRight';
import CloseIcon from '../../icons/utility/Close';
import DrawerCaretIcon from '../../icons/utility/DrawerCaret';
import DrawerCaretFlippedIcon from '../../icons/utility/DrawerCaretFlipped';
import ErrorNotificationFillIcon from '../../icons/utility/ErrorNotificationFill';
import MoreInfoStrokeIcon from '../../icons/utility/MoreInfoStroke';
import ProfileOutlineIcon from '../../icons/utility/ProfileOutline';
import SearchIcon from '../../icons/utility/Search';

const IconComponent = ({
  id, className, variant, ...otherProps
}) => {
  switch (variant) {
    // creative
    case 'beach-chair-with-border':
      return <BeachChairWithBorderIcon className={className} {...otherProps} />;
    case 'heart-shield-with-border':
      return <HeartShieldWithBorderIcon className={className} {...otherProps} />;
    case 'information-word-bubble':
      return <InformationWordBubbleIcon className={className} {...otherProps} />;
    case 'lightbulb':
      return <LightbulbIcon className={className} {...otherProps} />;
    case 'money-parachute-with-border':
      return <MoneyParachuteWithBorderIcon className={className} {...otherProps} />;
    case 'profile-outline-checkmark-with-border':
      return <ProfileOutlineCheckmarkWithBorderIcon className={className} {...otherProps} />;
    case 'umbrella-with-border':
      return <UmbrellaWithBorderIcon className={className} {...otherProps} />;
    case 'quotation':
      return <QuotationIcon className={className} {...otherProps} />;
    case 'shield-with-clock':
      return <ShieldWithClock className={className} {...otherProps} />;
    case 'shield-with-plus-sign':
      return <ShieldWithPlusSign className={className} {...otherProps} />;
    case 'thumbs-up':
      return <ThumbsUp className={className} {...otherProps} />;
    case 'woman-word-bubble-lightbulb':
      return <WomanWordBubbleLightbulb className={className} {...otherProps} />;

    // social
    case 'facebook':
      return <FacebookIcon className={className} {...otherProps} />;
    case 'instagram':
      return <InstagramIcon className={className} {...otherProps} />;
    case 'linkedin':
      return <LinkedinIcon className={className} {...otherProps} />;
    case 'pinterest':
      return <PinterestIcon className={className} {...otherProps} />;
    case 'twitter':
      return <TwitterIcon className={className} {...otherProps} />;
    case 'youtube':
      return <YoutubeIcon className={className} {...otherProps} />;

    // utility
    case 'alert-stroke':
      return <AlertStrokeIcon className={className} {...otherProps} />;
    case 'chevron-down':
      return <ChevronDownIcon className={className} {...otherProps} />;
    case 'chevron-left':
      return <ChevronLeftIcon className={className} {...otherProps} />;
    case 'chevron-right':
      return <ChevronRightIcon className={className} {...otherProps} />;
    case 'close':
      return <CloseIcon className={className} {...otherProps} />;
    case 'drawer-caret':
      return <DrawerCaretIcon className={className} {...otherProps} />;
    case 'drawer-caret-flipped':
      return <DrawerCaretFlippedIcon className={className} {...otherProps} />;
    case 'error-notification-fill':
      return <ErrorNotificationFillIcon className={className} {...otherProps} />;
    case 'more-info-stroke':
      return <MoreInfoStrokeIcon className={className} {...otherProps} />;
    case 'profile-outline':
      return <ProfileOutlineIcon className={className} {...otherProps} />;
    case 'search':
      return <SearchIcon className={className} {...otherProps} />;
    default:
      return <AlertStrokeIcon className={className} {...otherProps} />;
  }
};

IconComponent.propTypes = {
  /** Custom class name to add to Icon. */
  className: PropTypes.string,
  /** ID attribute for `Icon`. */
  id: PropTypes.string,
  /**  Determines the look and feel of the Icon */
  variant: PropTypes.oneOf([
    'beach-chair-with-border',
    'heart-shield-with-border',
    'information-word-bubble',
    'lightbulb',
    'money-parachute-with-border',
    'profile-outline-checkmark-with-border',
    'umbrella-with-border',
    'quotation',
    'shield-with-clock',
    'shield-with-plus-sign',
    'thumbs-up',
    'woman-word-bubble-lightbulb',

    'facebook',
    'instagram',
    'linkedin',
    'pinterest',
    'twitter',
    'youtube',

    'alert-stroke',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'close',
    'drawer-caret',
    'drawer-caret-flipped',
    'error-notification-fill',
    'more-info-stroke',
    'profile-outline',
    'search',
  ]),
};

// IconComponent.defaultProps = {
//   className: 'nmx-icon',
//   variant: 'alert-stroke',
// }

export default IconComponent;
